
export default {
  cities: []
};
